import type { Campaign, CreatedByRole, User } from "../shared/types";

export function createdByRoleFromUser(user: Pick<User, "roles"> | undefined): CreatedByRole {
    return user?.roles?.manager ? "manager" : "booker";
}

export function campaignCreatedByRole(
    campaign: Pick<Campaign, "createdByRole">,
): CreatedByRole {
    return campaign.createdByRole ?? "booker";
}

export function isCampaignOwner(
    user: User | undefined,
    campaign: Pick<Campaign, "createdById">,
): boolean {
    return Boolean(user?.id && campaign.createdById === user.id);
}

export function canCreateCampaign(user: User | undefined): boolean {
    return Boolean(user?.roles?.manager || user?.roles?.booker);
}
